// extracted by mini-css-extract-plugin
export var printerCard = "_gs-1";
export var printerCardConfigured = "_gs-2";
export var printerCardError = "_gs-3";
export var printerCardsContainer = "_gs-0";
export var printerIcon = "_gs-8";
export var printerIconConfigured = "_gs-5";
export var printerIconContainer = "_gs-4";
export var printerIconError = "_gs-6";
export var printerIconUnconfigured = "_gs-7";
export var workstationsTableCard = "_gs-9";